module.exports = __webpack_public_path__ + "media/images/stage5-de589006.png";